<template>
  <MainWrapper>
    <div class="companies-control-panel mb-30">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="companies-control-panel-inner">
                        <router-link :to="`/companies/${$route.params.slug}/admin`" class="mr-20">
                            <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'arrow-circle-left']" />
                            <span class="dark-body-text panel-body-text">Назад к компании</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>

      <div class="single-master-page">
          <div class="container">
              <div class="row">
                  <div class="col-lg-12">
                      <h3 class="mb-30">Добавить специалиста</h3>
                  </div>
              </div>
              <div class="row">
                  <div class="col-lg-12">
                      <div class="white-panel pt-20 pb-20 pr-20 pl-20">
                          <div class="container-fluid">
                              <div class="row">
                                  <div class="col-lg-6 no-p">
                                      <p class="dark-body-text mb-10">Данные специалиста</p>
                                      <p class="mb-30">Заполните все поля. Это необходимое условие для записи к специалистам и обеспечению безопасности вашей учетной записи.</p>
                                      <div class="input-wrapper mb-30">
                                          <select v-model="master.whois" class="rounded-input">
                                              <option value="user">Специалист</option>
                                              <option value="serv">Оборудование</option>
                                          </select>
                                      </div>
                                      <div class="input-wrapper mb-10">
                                          <input class="rounded-input" type="text" v-model="master.full_name" placeholder="Иванов Иван" />
                                      </div>
                                      <div class="input-wrapper mb-10">
                                          <masked-input v-model="master.phone" mask="\9\9\6 111 11 11 11" placeholder-char=" " type="tel" class="rounded-input" />
                                          <!--<input class="rounded-input" type="tel" v-model="master.phone" placeholder="996556088891" />-->
                                      </div>
                                      <div class="input-wrapper mb-10">
                                          <input v-model="master.password" class="rounded-input" type="password" placeholder="Введите пароль" />
                                      </div>
                                      <div class="input-wrapper mb-30">
                                          <input v-model="master.password_confirm" class="rounded-input" type="password" placeholder="Повторите пароль" />
                                      </div>
                                      <!--
                                      <p class="gray-body-text mb-15">Ваш адрес</p>
                                      <textarea class="mb-15" placeholder="г. Бишкек ул. Исанова 70а" v-model="master.street_address"></textarea>
                                      -->
                                      <p class="gray-body-text mb-15">Краткое описание отображается на странице всех специалистов</p>
                                      <vue-editor id="short_info" v-model="master.short_info" :editorToolbar="customToolbar" class="mb-15" placeholder="Краткое описание ваших услуг"></vue-editor>
                                      <!--<textarea class="mb-15" placeholder="Краткое описание ваших услуг" v-model="master.short_info"></textarea>-->
                                      <p class="gray-body-text mb-15">Полное описание отображается у вас на странице</p>
                                      <vue-editor id="full_info" v-model="master.full_info" :editorToolbar="customToolbar" class="mb-15" placeholder="Полное описание ваших услуг"></vue-editor>
                                      <!--<textarea class="mb-15" placeholder="Полное описание ваших услуг" v-model="master.full_info"></textarea>-->
                                      <p class="gray-body-text mb-15">Укажите вашу специальность</p>

                                      <div v-if="master.categories.length > 0" class="input-wrapper mb-10" v-for="item, i in master.categories" :key="item.id">
                                          <input class="rounded-input mr-15" style="background:#e0e0e0" type="text" :value="item.name" disabled />
                                          <span @click="unsetCategories(i)" class="red-body-text pointer">Удалить</span>
                                      </div>

                                      <div class="input-wrapper">
                                          <select class="rounded-input" v-model="cat_level1" @change="setCategoriesLevel2()">
                                              <option value="0" disabled>Выберите категорию</option>
                                              <option v-for="cat, i in categories" :key="cat.id" :value="cat.slug">{{ cat.name }}</option>
                                          </select>
                                      </div>

                                      <div v-if="level2.length > 0" class="input-wrapper mt-10">
                                          <select class="rounded-input" v-model="cat_level2" @change="setCategoriesLevel3()">
                                              <option value="0" disabled>Выберите категорию</option>
                                              <option v-for="cat, i in level2" :key="cat.id" :value="cat.slug">{{ cat.name }}</option>
                                          </select>
                                      </div>
                                      <div v-if="level3.length > 0" class="input-wrapper mt-10">
                                          <select class="rounded-input" v-model="cat_level3" @change="setCategories()">
                                              <option value="0" disabled>Выберите категорию</option>
                                              <option v-for="cat, i in level3" :key="cat.id" :value="cat.id+':::'+cat.name+':::'+cat.slug">{{ cat.name }}</option>
                                          </select>
                                      </div>
                                      <p class="gray-body-text mt-30 mb-15">Список ваших услуг</p>
                                      <div class="input-wrapper mb-10" v-for="item,k in master.service" :key="k">
                                          <input v-model="master.service[k].name" class="rounded-input" type="text" />
                                          <vue-timepicker :format="'HH:mm'" v-model="master.service[k].duration" class="rounded-input ml-10" style="width:100px"></vue-timepicker>
                                          <!--
                                          <select v-model="master.service[k].duration.substr(0,5)" class="rounded-input ml-10" style="width:100px" placeholder="Укажите длительность">
                                              <option value="00:15">00:15</option>
                                              <option value="00:30">00:30</option>
                                              <option value="00:45">00:45</option>
                                              <option value="01:00">01:00</option>
                                          </select>
                                          -->
                                          <input v-model="master.service[k].price" class="rounded-input ml-10 mr-15" style="width:120px" type="text" placeholder="Стоимость" />
                                          <span @click="unsetService(k)" class="red-body-text pointer">Удалить</span>
                                      </div>
                                      <hr v-if="master.service.length > 0" />
                                      <div class="input-wrapper mb-15">
                                          <input v-model="service_title" class="rounded-input" type="text" placeholder="Тип сервиса" />
                                          <vue-timepicker :format="'HH:mm'" v-model="service_duration" class="rounded-input ml-10" style="width:100px"></vue-timepicker>
                                          <!--
                                          <select v-model="service_duration" class="rounded-input ml-10" style="width:100px" placeholder="Укажите длительность">
                                              <option value="00:15">00:15</option>
                                              <option value="00:30">00:30</option>
                                              <option value="00:45">00:45</option>
                                              <option value="01:00">01:00</option>
                                          </select>
                                          -->
                                          <input v-model="service_price" class="rounded-input ml-10" style="width:120px" type="text" placeholder="Стоимость" />
                                      </div>
                                      <div class="button-wrapper mb-30">
                                          <Button @click="setService" style="width:135px" type="gray" text="Добавить" />
                                      </div>
                                      <div class="button-wrapper mt-30">
                                          <Button type="blue" text="Сохранить" @click="createMaster" />
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
    @import '../../styles/main.core.vars.styl';

    .spec-categories
        padding: 20px 60px 30px 20px

    .spec-categories-header
        display: flex
        .spec-count
            margin: 0 0 0 auto
            color: $gray_text

    .spec-categories-single
        display: flex
        align-items: center
        >.icon
            margin-left: auto
            font-size: 16px

    .companies-control-panel
        margin-top: -30px
        height: 56px
        background: $black_text
        .panel-body-text, .panel-icon
            color: #fff
        &-inner
            height: 56px
            display: flex
            align-items: center
        input
            width: 430px

    .col-lg-1
        min-height: 0

    .arr-down
        position: absolute
        bottom: -2px
        width: 0
        height: 0
        border-left: 9px solid transparent
        border-right: 9px solid transparent
        border-bottom: 9px solid $black_text
        z-index: 4
        left: 0
        right: 0
        margin: auto

    .spec-search-icon
        position: absolute
        top: 0
        bottom: 0
        margin: auto
        left: 15px
        color: $dark_gray_text

    .spec-search
        width: 420px
        padding: 9px 15px 10px 40px

    .spec-search-wrapper
        position: relative

    .spec-img
        width: 50px
        height: 50px
        border-radius: 100%
        background: cyan_dark_color
        /* margin-left: 5px */
        background-size: cover
        background-position: center
        /* display: flex */
        align-items: center
        justify-content: center
        h3
            color: #fff
            margin: 0
            font-size: 36px
            text-align: center
            line-height: 48px

    textarea
        border-radius: 8px
        border: 1px solid $light_gray
        padding: 10px 15px
        width: 500px
        max-width: 100%
        min-height: 150px

    input[type="file"]
        display: none
    
</style>
<script>
    import { Component, Vue, Watch } from "vue-property-decorator";
    import MainWrapper from '@/wrappers/MainWrapper.vue';
    import Button from '@/components/Button.vue';
    import Specialist from '@/components/Specialist.vue';
    import Paginator from '@/components/Paginator.vue';
    import VueTimepicker from 'vue2-timepicker';
    import Holder from '@/components/Holder.vue';
    import MaskedInput from 'vue-masked-input';
    import http from '@/methods/http.ts';
    import { VueEditor } from 'vue2-editor';

    @Component({
        components: {
            MainWrapper,
            Button,
            Specialist,
            Paginator,
            VueTimepicker,
            Holder,
            MaskedInput,
            VueEditor
        }
    })
    export default class CompanyAdmin extends Vue {

        data() {
            return {
                customToolbar: [
                    ['bold', 'italic', 'underline'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }]
                ]
            }
        }

        photo = '';
        categories = [];
        level2 = [];
        level3 = [];
        cats = 0;
        cat_level1 = 0;
        cat_level2 = 0;
        cat_level3 = 0;

        service_title = '';
        service_duration = {HH: null, mm: null};
        service_price = '';

        master = {
            full_name: '',
            phone: '',
            password: '',
            password_confirm: '',
            street_address: '',
            short_info: '',
            full_info: '',
            categories: [],
            service: [],
            avatar: 0,
            org_id: '',
            whois: 'user'
        };

        unsetCategories(idx) {
            this.master.categories.splice(idx, 1);
        }

        setCategories() {
            let params = this.cat_level3;
            params = params.split(':::');

            this.master.categories.push({
                id: params[0],
                name: params[1],
                slug: params[2]
            });
            this.cat_level1 = 0;
            this.cat_level2 = 0;
            this.cat_level3 = 0;
            this.level2 = [];
            this.level3 = [];
        }

        setCategoriesLevel2() {
            this.cat_level2 = 0;
            this.cat_level3 = 0;
            this.level2 = [];
            this.level3 = [];
            let url = 'categories/'+this.cat_level1;
            http(url, 'get', false, {}).then(r => {
                this.level2 = r.data.children;
            })
        }

        setCategoriesLevel3() {
            let url = 'categories/'+this.cat_level2;
            http(url, 'get', false, {}).then(r => {
                this.level3 = r.data.children;
            })
        }

        pickPhoto(names, files) {
            let pk = this.master.user;
            let data = new FormData();

            data.append('file', files[0]);

            axios.post(`https://checkin.kg/api/v1/master/${pk}/photo/`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then(r => {
                if (r.data.success === true) {
                    this.photo = r.data.url;
                    this.$store.commit('notificate', { text: 'Фото профиля обновлено', type: 'action' });
                }
            }).catch(r => {
                this.$store.commit('notificate', { text: 'Введены неверные данные', type: 'error' });
            });
        }

        setService() {
            if (this.service_title === '') {
                this.$store.commit('notificate', { text: 'service_title is empty', type: 'error' });
                return false;
            }
            if ((this.service_duration.HH === null || this.service_duration.HH === '') || (this.service_duration.mm === null || this.service_duration.mm === '')) {
                this.$store.commit('notificate', { text: 'service_duration is empty', type: 'error' });
                return false;
            }
            if (this.service_price === '') {
                this.$store.commit('notificate', { text: 'service_price is empty', type: 'error' });
                return false;
            }
            this.master.service.push({
                'name': this.service_title,
                'duration': this.service_duration,
                'price': this.service_price
            });
            this.service_title = '';
            this.service_duration = {HH: null, mm: null};
            this.service_price = '';
        }

        unsetService(idx) {
            this.master.service.splice(idx, 1);
        }

        createMaster() {
            let url = 'companies/'+this.$route.params.slug+'/add-specialist';
            http(url, 'post', this.$store.state.token, this.master).then(r => {
                if (r.data.success === true) {
                    url = '/companies/'+this.$route.params.slug+'/admin';
                    this.$router.push(url);
                }
            }).catch(error => {
                this.$store.commit('notificate', { text: error.response.data.message, type: 'error' });
            });
        }

        getCategories() {
            http('categories/main', 'get', false, {}).then(r => {
                this.categories = r.data;
            })
        }

        getCompany() {
            http(`companies/${this.$route.params.slug}`, "get", false, {}).then(r => {
                this.master.org_id = r.data.id;
                this.master.street_address = r.data.street_address;
            })
        }

        created() {
            this.getCompany();
            this.getCategories();
        }
    }
</script>